import { IModel } from "makerjs";
import { makerjs } from "../../../../source/js/shared/rendering/makerjs";
import { InterfaceModelDecorator } from "./PreviewModelDecorator";
import Cutout from "@/Models/Cutout";
import { renderLength } from "@/functions/lengths";
import { getShapeModelCenter } from "@/functions/makerjs";

export class CutoutRotationDecorator implements InterfaceModelDecorator {
	constructor(
		private parentDecorator: InterfaceModelDecorator | null,
		private cutout: Cutout
	) {}

	getModel(): IModel {
		let model = { models: {} } as IModel;

		if (this.parentDecorator) {
			model = this.parentDecorator.getModel();
		}

		if ( typeof model.models.shapeModel === 'undefined' ) {
			return model;
		}

		const center = getShapeModelCenter(model.models.shapeModel.models.baseModel);

		makerjs.model.rotate(model.models.shapeModel, this.cutout.attributes.rotation, center);

		return model;
	}

}

export class CutoutRotationIndicatorDecorator implements InterfaceModelDecorator {
	constructor(
		private parentDecorator: InterfaceModelDecorator | null,
		private cutout: Cutout
	) {}

	getModel(): IModel {
		let model = { models: {} } as IModel;

		if (this.parentDecorator) {
			model = this.parentDecorator.getModel();
		}

		const rotationAngle = this.cutout.attributes.rotation;

		if (rotationAngle === 0) {
			return model;
		}

		const center = getShapeModelCenter(model.models.shapeModel.models.baseModel);
		const size = 45;
		const baseLine = new makerjs.paths.Line(center, [center[0] + size, center[1]]);
		const rotationLine = new makerjs.paths.Line(center, [center[0] + size, center[1]]);
		const arcLine = new makerjs.paths.Arc(center, size - 10, 0, rotationAngle);

		const rotationModel = {} as IModel;
		makerjs.path.rotate(rotationLine, rotationAngle, center);
		makerjs.model.addPath(rotationModel, baseLine, 'base-line');
		makerjs.model.addPath(rotationModel, rotationLine, 'rotation-line');
		makerjs.model.addPath(rotationModel, arcLine, 'arc-line');
		makerjs.model.addCaption(rotationModel, renderLength(rotationAngle, '°'), [center[0] + size - 20, center[1] - 20]);

		// Reverse the roation to make sure the rotation indicator is always straight
		makerjs.model.rotate(rotationModel, -rotationAngle, center);
		rotationModel.layer = 'rotation-indicator';

		makerjs.model.addModel(model, rotationModel, 'rotationModel');
		return model;
	}
}
